module.exports = __webpack_public_path__ + "media/entities/2308-9dd1428c.png";